import ExternalTeasers from 'app/components/ExternalTeasers/ExternalTeasers';
import { useRouter } from 'next/router';
import React from 'react';
import { ButtonLabel } from '../../ui-components/PlayButton/PlayButton.styles';
import { PlayContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import PlayText, { SIZE } from '../../ui-components/typography/PlayText/PlayText';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { footerClickEvent } from '../../utils/statistics/customEvents';
import ExternalIcon from '../ExternalLink/ExternalIcon/ExternalIcon';
import Devices from './components/Devices';
import FooterGenres from './components/FooterGenres/FooterGenres';
import {
    CogIcon,
    FooterLogo,
    ServiceLink,
    ServicesLinkWrapper,
    Button,
    Buttons,
    FooterContainer,
    IconContainer,
    Service,
    Services,
} from './Footer.styles';

const trackClick = (name: string): void => {
    const event = footerClickEvent(name);
    trackCustomEvent(event);
};

const Footer = (): JSX.Element => {
    const router = useRouter();
    const isStartpage = router.asPath === '/';

    return (
        <FooterContainer>
            <PlayContainerBase>
                {isStartpage && <ExternalTeasers />}
                <FooterGenres onGenreClick={trackClick} />
                <Devices
                    onDeviceClick={(name) => {
                        trackClick(name);
                    }}
                />
                <Buttons data-rt="footer-buttons">
                    <Button
                        to="/installningar"
                        onClick={() => {
                            trackClick('Inställningar');
                        }}
                        className="lp_pos1"
                    >
                        <CogIcon aria-hidden="true" />
                        <ButtonLabel>Inställningar</ButtonLabel>
                    </Button>
                    <Button
                        to="https://kontakt.svt.se"
                        className="lp_pos2"
                        onClick={() => {
                            trackClick('Kontakt');
                        }}
                    >
                        <ExternalIcon isExternal>
                            <ButtonLabel>Kontakt</ButtonLabel>
                        </ExternalIcon>
                    </Button>
                </Buttons>
                <IconContainer>
                    <FooterLogo />
                    <PlayText size={SIZE.MINI}>Sveriges Television AB</PlayText>
                </IconContainer>
                <Services>
                    <ServicesLinkWrapper>
                        <Service data-rt="footer-element">
                            <ServiceLink
                                href="https://www.svt.se"
                                onClick={() => {
                                    trackClick('svt.se');
                                }}
                            >
                                svt.se
                            </ServiceLink>
                        </Service>
                        <Service data-rt="footer-element">
                            <ServiceLink
                                href="https://nyhetsbrev.svtplay.se/prenumerera/?utm_source=svtplay&utm_medium=footer-cta"
                                onClick={() => {
                                    trackClick('Nyhetsbrev');
                                }}
                            >
                                Nyhetsbrev
                            </ServiceLink>
                        </Service>
                    </ServicesLinkWrapper>
                    <ServicesLinkWrapper>
                        <Service data-rt="footer-element">
                            <ServiceLink
                                href="https://kontakt.svt.se/guide/tillganglighet"
                                onClick={() => {
                                    trackClick('Tillgänglighet');
                                }}
                            >
                                Tillgänglighet i SVT Play
                            </ServiceLink>
                        </Service>
                        <Service data-rt="footer-element">
                            <ServiceLink
                                href="https://kontakt.svt.se/guide/cookies-och-personuppgifter"
                                onClick={() => {
                                    trackClick('Om cookies');
                                }}
                            >
                                Om cookies
                            </ServiceLink>
                        </Service>
                    </ServicesLinkWrapper>
                </Services>
            </PlayContainerBase>
        </FooterContainer>
    );
};

export default Footer;
